(function () {
	const initProductAccordion = () => {
		const aboutToggleItems = $(".about__accordion-toggle");

		aboutToggleItems.each(function () {
			const currentToggle = $(this);
			const siblingToggles = currentToggle.siblings(
				".about__accordion-description"
			);

			currentToggle.click(function () {
				if (!currentToggle.hasClass("active")) {
					aboutToggleItems.each(function () {
						const siblingToggle = $(this);
						siblingToggle.removeClass("active");
						siblingToggle
							.siblings(".about__accordion-description")
							.stop()
							.slideUp(300);
					});

					currentToggle.addClass("active");

					siblingToggles.stop().slideDown(300);
				} else {
					currentToggle.removeClass("active");
					siblingToggles.stop().slideUp(300);
				}
			});
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper?.querySelectorAll(".js-image-zoom") || [];

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatString = theme.moneyFormat;

		return formatString.replace(placeholderRegex, value);
	};

	const setTotalFreeShipping = () => {
		if (document.querySelector(".js-free-shipping")) {
			const freeShippingTotal = document.querySelector(".free-shipping-total");
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend);
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(
						Math.round(minSpend * (Shopify.currency.rate || 1))
					)}`;
				}
			}
		}
	};

	const revealStickyAddToCart = (section) => {
		if (!section && section.classList.contains(".product-section")) return;
		const buyButtons = section.querySelector(
			".product__buy-buttons > product-form"
		);
		const stickyBar = section.querySelector(".sticky-add-to-cart");
		const footerBottom = document.querySelector(
			".shopify-section-group-footer-group .footer__content-bottom"
		);

		if (!stickyBar) return;

		const observerOptions = {
			root: null,
			rootMargin: "0px",
			threshold: 0.01,
		};

		const isElementBelowScroll = (element) => {
			return element ? element.getBoundingClientRect().top > 0 : false;
		};

		const toggleStickyBar = (isVisible) => {
			if (isVisible || isElementBelowScroll(buyButtons)) {
				stickyBar.classList.remove("active");
			} else {
				stickyBar.classList.add("active");
			}
		};

		const handleIntersect = (entries) => {
			const isVisible = entries.some((entry) => entry.isIntersecting);
			toggleStickyBar(isVisible);
		};

		const observer = new IntersectionObserver(handleIntersect, observerOptions);

		if (buyButtons) observer.observe(buyButtons);
		if (footerBottom) observer.observe(footerBottom);
	};

	const setRadioValue = () => {
		document.querySelectorAll(".product-form__controls").forEach((fieldset) => {
			const legendSpan = fieldset.querySelector(".selected-value");
			if (!legendSpan) return;

			const radios = fieldset.querySelectorAll('input[type="radio"]');

			radios.forEach((radio) => {
				radio.addEventListener("change", function () {
					if (this.checked) {
						legendSpan.textContent = this.value;
					}
				});
			});
		});
	};

	const setTabsText = () => {
		const reviewsTab = document.getElementById("testimonials-tab");
		const allFeaturesTab = document.getElementById("all-features-tab");
		const reviewsSection = document.getElementById("testimonials-quote");
		const mediaSection = document.getElementById("media-section");
		const descriptionGridSection = document.getElementById(
			"description-grid-section"
		);
		const imageWithTextSection = document.getElementById(
			"image-with-text-section"
		);
		const simpleCardsSection = document.getElementById("simple-cards-section");
		const instructionsTab = document.getElementById("instructions-tab");
		const instructionsBlock = document.getElementById("instructions");

		/*
		 * REVIEWS TAB DETECTION
		 * ---------------------
		 * The Reviews tab is kept visible if ANY of these exist:
		 *   1. An element with id="testimonials-quote" (legacy/manual approach)
		 *   2. A Judge.me section (detected by ID containing "judge_me" or class "jdgm-widget")
		 *
		 * FUTURE-PROOFING:
		 * If you switch to a different reviews app (e.g., Loox, Yotpo, Stamped):
		 *   Option A: Add id="testimonials-quote" to your new reviews section wrapper
		 *   Option B: Add a new selector below for your reviews app
		 *
		 * Example for other apps:
		 *   const looxSection = document.querySelector('.loox-reviews-widget');
		 *   const yotpoSection = document.querySelector('.yotpo-widget');
		 *   Then add to the condition: !looxSection && !yotpoSection
		 */
		const judgeMeSection = document.querySelector('[id*="judge_me_reviews"]') ||
			document.querySelector('[id*="judge_me"]') ||
			document.querySelector('.jdgm-widget');

		// Only remove reviews tab if NEITHER testimonials-quote NOR Judge.me section exists
		if (!reviewsSection && !judgeMeSection && reviewsTab) {
			reviewsTab.remove();
		}

		if (!instructionsBlock && instructionsTab) {
			instructionsTab.remove();
		}

		if (
			!mediaSection &&
			!descriptionGridSection &&
			!imageWithTextSection &&
			!simpleCardsSection &&
			allFeaturesTab
		) {
			allFeaturesTab.remove();
		}
	};

	function hideTabsIfSingle() {
		const track = document.querySelector(".tabs-lava-lamp");
		const navItems = document.querySelectorAll(
			".tabs-lava-lamp li:not(#tabs-lava-lamp-blob)"
		);

		if (track && navItems.length <= 1) {
			track.style.display = "none";
			return true;
		}
		return false;
	}

	const initStickyTabs = () => {
		const tabs = document.querySelector(".sticky-tabs");
		if (!tabs) return;

		// Create sentinel for intersection detection
		const sentinel = document.createElement("div");
		sentinel.style.height = "1px";
		sentinel.className = "sticky-tabs-sentinel";
		tabs.parentNode.insertBefore(sentinel, tabs);

		// Create placeholder to prevent content jump when tabs become fixed
		const placeholder = document.createElement("div");
		placeholder.className = "sticky-tabs-placeholder";
		placeholder.style.display = "none";
		placeholder.style.height = "0px";
		tabs.parentNode.insertBefore(placeholder, tabs.nextSibling);

		let isFixed = false;

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					const shouldBeFixed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
					
					// Only act if state actually changes
					if (shouldBeFixed && !isFixed) {
						// Store the height before fixing
						const tabsHeight = tabs.offsetHeight;
						placeholder.style.height = tabsHeight + "px";
						placeholder.style.display = "block";
						
						tabs.classList.add("is-fixed");
						tabs.classList.add("container");
						isFixed = true;
					} else if (!shouldBeFixed && isFixed) {
						tabs.classList.remove("is-fixed");
						tabs.classList.remove("container");
						placeholder.style.display = "none";
						placeholder.style.height = "0px";
						isFixed = false;
					}
				});
			},
			{ threshold: 0 }
		);

		observer.observe(sentinel);
	};

	document.addEventListener("shopify:section:load", function (event) {
		initProductAccordion();
		initZoomImage();
		setTotalFreeShipping();
		revealStickyAddToCart(event.target);
		initStickyTabs();
		setRadioValue();
		setTabsText();
		hideTabsIfSingle();
	});

	initProductAccordion();
	initZoomImage();
	setTotalFreeShipping();
	revealStickyAddToCart(document.currentScript.parentElement);
	initStickyTabs();
	setRadioValue();
	setTabsText();
	hideTabsIfSingle();
})();
